import React from "react";

import CustomCardComponent from "./customCard";

export type IContent = {
  id: string;
  _id?: string | undefined;
  title: string;
  title1?: string | React.ReactNode;
  children?: React.ReactNode;
  option?: React.ReactNode;
  logo?: any;
  icon?: any;
  dataFields?: any;
};

export const CustomCard = CustomCardComponent;
